export default __webpack_public_path__ + "static/media/sales.8863c6aa.png";